import { Routes } from '@angular/router';
import { ConnectComponent } from './pages/connect/connect.component';
import { TiktokCallbackComponent } from './pages/tiktok-callback/tiktok-callback.component';
import { InstagramCallbackComponent } from './pages/instagram-callback/instagram-callback.component';
import { InstagramLoginComponent } from './pages/instagram-login/instagram-login.component';
import { FbInstagramCallbackComponent } from './pages/fb-instagram-callback/fb-instagram-callback.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { EnterTiktokComponent } from './pages/enter-tiktok/enter-tiktok.component';
import { EnterInstagramComponent } from './pages/enter-instagram/enter-instagram.component';
import { EnterTiktokCompleteComponent } from './pages/enter-tiktok-complete/enter-tiktok-complete.component';
import { EnterInstagramCompleteComponent } from './pages/enter-instagram-complete/enter-instagram-complete.component';
import {EnterYoutubeComponent} from './pages/enter-youtube/enter-youtube.component';
import {EnterYoutubeCompleteComponent} from "./pages/enter-youtube-complete/enter-youtube-complete.component";

export const routes: Routes = [
    { path: '', redirectTo: '/welcome', pathMatch: 'full' },
    { path: 'connect/:externalId/:businessId', component: ConnectComponent },
    // { path: 'tiktok/auth/callback/', redirectTo: '/tiktok-callback', pathMatch: 'full' },
    { path: 'tiktok/auth/callback/', redirectTo: '/tiktok-callback', pathMatch: 'full' },
    { path: 'tiktok-callback', component: TiktokCallbackComponent },
    { path: 'welcome', component: WelcomeComponent },
    { path: 'tiktok/auth/callback', component: TiktokCallbackComponent },
    { path: 'instagram-callback', component: InstagramCallbackComponent },
    { path: 'instagram-login', component: InstagramLoginComponent },
    { path: 'fb-instagram-callback', component: FbInstagramCallbackComponent },
    { path: 'enter-tiktok', component: EnterTiktokComponent },
    { path: 'enter-instagram', component: EnterInstagramComponent },
    { path: 'enter-tiktok-complete', component: EnterTiktokCompleteComponent },
    { path: 'enter-instagram-complete', component: EnterInstagramCompleteComponent },
    { path: 'enter-youtube', component: EnterYoutubeComponent },
    { path: 'enter-youtube-complete', component: EnterYoutubeCompleteComponent },
];
